import { DataBean } from "../DataBean";

export class CreateCashReimbursement extends DataBean {


    public async createCashReimbursement(year:any,idCashDeskAccount:any,accountantDate:any,idCashDeskAccountCDP:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createCashReimbursement_Number_Number_java.util.Date_Number_Number", [year,idCashDeskAccount,accountantDate,idCashDeskAccountCDP,idEmployee]);
    }

}